var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"echarts"},[_c('div',{ref:"myEchart",style:({height:'600px',width:'900px',border:'1px solid red'})})])}
var staticRenderFns = []

export { render, staticRenderFns }